// import Index from '../src/App/routes/index';
// import AppLayout from './App/layout/AppLayout';
// import HeaderWithLeftDrawer from './App/partail/Applayout';
// import HeaderWithClickDrawer from './App/partail/Applayout';

// import LeftSidebar from './App/partail/drawerc';
// import PractoHeader from './App/partail/header';

// function App() {
//   return (
//  <>
//   {/* <h1> heelo world</h1> */}
//     <AppLayout/>
//    {/* <LeftSidebar/> */}
//       {/* < PractoHeader/>*/}
// {/* <HeaderWithClickDrawer/> */}
//    {/* <AppLayout/> */} 
//  </>
//   );
// }

// export default App;
import * as React from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./App/routes/index";
import VitalsPage from "./App/vitals/pages/VitalsPage";
import LoginPage from "./App/Auth/pages/LoginPage";

export default function App() {
  return (
    <>
    
      <RouterProvider router={router} />
    
    </> 
  );
}